import { detect } from 'detect-browser';
import printJS from 'print-js';
import { authHeader } from '../helpers/auth-header';
import { client } from '../actions';

const getRequestsFileToPrint = async (requestsIds, ex) => {
  return client
    .get(`/Request/get_pdf?requestids=${requestsIds}`, {
      headers: authHeader(),
    })
    .then((res) => {
      const browser = detect();
      const b = Buffer.from(res.data, 'base64');

      if (
        !ex &&
        browser &&
        (browser.name === 'chrome' ||
          browser.name === 'opera' ||
          browser.name === 'safari')
      ) {
        const pdf = new Blob([b], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdf);
        printJS({ printable: pdfUrl, type: 'pdf' });
      } else {
        const url = window.URL.createObjectURL(new Blob([b]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `dispex_print_${requestsIds[0]}_${requestsIds[requestsIds.length - 1]}.pdf`
        );
        document.body.appendChild(link);
        link.click();
      }
    });
};

export default getRequestsFileToPrint;
